import {middleware, createMany, path, expr, alias, incomplete} from '@acng/frontend-voyager';
import {main} from '../service/location.js';

import {footerView, mainView} from 'acng/layout/service/sequence.js';
import {coreFeature, hookFeature} from './feature.js';
import {portal} from '../portal.js';
import {authUser} from '../../userPool/context/auth-user.js';

main.config(
  middleware((next) => {
    next.portal = portal;
    next.level = authUser?.level; // not used a.t.m. just a fix for bootstrap
    next.locale = document.body.lang;
  }),
  createMany(
    [path('/privacyPolicy'), mainView(hookFeature, 'privacyPolicy')],
    [path('/terms'), mainView(hookFeature, 'terms')],
    [path('/imprint'), mainView(hookFeature, 'imprint')],
    [path('/contentRemoval'), mainView(coreFeature, 'content-removal')],

    [incomplete, expr(/(?:\/movies(?:\/(?:top|new|classics))?|\/pictures\/sets(?:\/(?:top|new|classics))?)$/), alias('gallerySearch')],
    [incomplete, expr(/^\/(?!livecamShow|hotornot$)/y), footerView(coreFeature, 'footer'), alias('footer')]
  )
);
